import React, { Fragment, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { translate } from '../../Services/translation';
import ListViewProductItem from './ListViewProductItem';

const ListViewModelContainer = (props) => {
  const [titles, setTitleValue] = useState(
    props.excludeparsing == false ? JSON.parse(props.heading) : props.heading
  );
  const [products, setProducts] = useState(
    props.excludeparsing == false ? JSON.parse(props.products) : props.products
  );

  const [isChassiSearch, setIsChassiSearch] = useState(
    props.isChassiSearch ? props.isChassiSearch : false
  );

  const isRecommendedPrice = useSelector((state) => state.recommendedprice.isrecommendedprice);
  const {hidePrices} = window.__litium.channelConfig;

  let isEvenRow = false;

  const getRowClass = (hasAltItem) => {
    if (!hasAltItem) {
      isEvenRow = !isEvenRow;
    }

    return `product-list-view--${isEvenRow ? 'even' : 'odd'}`;
  };

  const removeProduct = (id) => {
    const newProducts = products.filter(product => product.Id !== id);
    setProducts(newProducts);
  };

  const totalPriceCount =
    products &&
    products.length > 0 &&
    products.filter(
      (x) =>
        x.IsExpired == false &&
        x.Price != null &&
        x.Price.TierPrices != null &&
        x.Price.TierPrices.length > 1
    ).length > 0;

  const showStockStatus = products.some((x => x.ShouldShowStockStatus))

  const specificationTitles =
    products && products.length < 1
      ? null
      : products[0].SpecificationForProductPage;


  return (
    <Fragment>
      <div className="tablediv">
        <table className="product-listview-table defaulttable">
          <thead className="product-list-view-head">
            <tr>
              <th aria-label={translate('product.productphoto')} >{translate('product.productphoto')}</th>
              {isChassiSearch == true && (
                <th aria-label={translate('product.articlenumber')}>{translate('product.articlenumber')}</th>
              )}
              <th className={isChassiSearch ? 'chassi' : ''}>{translate('product.productmodel')}</th>
              {specificationTitles &&
                specificationTitles.map((key, i) => (
                  <th aria-label={key.Name} key={'th-spec' + i}>
                    {key.Name}
                    {key.Description && (
                      <span className="product-tooltip">
                        ?
                        <span
                          data-tip={key.Description}
                          className="product-tooltip--content"
                        ></span>
                      </span>
                    )}
                  </th>
                ))}
              {!hidePrices && totalPriceCount && (
                <th aria-label={translate('product.volumediscount')} className="min-witdh--small">
                  {translate('product.volumediscount')}
                </th>
              )}
              {(
                (showStockStatus) ? (
                  <th aria-label={translate('common.stock')} className="min-witdh--small">
                    {translate('common.stock')}
                  </th>
                ) : <th></th>
              )}
              {!hidePrices && (
              <th aria-label={translate(
                  isRecommendedPrice ? 'product.rekpris' : 'product.netprice'
                )} className="min-witdh--small">
              {translate(
                  isRecommendedPrice ? 'product.rekpris' : 'product.netprice'
                )}
              </th>
              )}
              <th aria-label={props.isClickAndCollect ? "" : translate('product.quantity')} className="min-witdh--small">
                {props.isClickAndCollect ? "" : translate('product.quantity')}
              </th>
            </tr>
          </thead>
          <tbody>
            {products && //key is changed to productsystemid, need to test product listings carefully
              products.map((product, index) => {
                return (
                  <Fragment key={product.SystemId}>
                    <ListViewProductItem
                      authenticated={props.authenticated}
                      products={products}
                      product={product}
                      isChassiSearch={isChassiSearch}
                      isClickAndCollect={props.isClickAndCollect}
                      totalPriceCount={totalPriceCount}
                      trClassName={getRowClass(product.IsAltItem)}
                      hideDescription={props.hidedescription}
                      removeProduct={removeProduct}
                    />
                  </Fragment>
                );
              })}
          </tbody>
        </table>
      </div>
    </Fragment>
  );
};

export default ListViewModelContainer;
